import styled from "styled-components";
import {colors} from "../../../../themes";

export const SeparatorWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 11px;
  > img {
    width: 24px;
  }
`;

export const Line = styled.div`
  flex: 1;
  border: 1px solid ${colors.border.poloBlue};
`;
